import { render, staticRenderFns } from "./RestaurantTabsNotes.vue?vue&type=template&id=232e85e9&scoped=true&"
import script from "./RestaurantTabsNotes.vue?vue&type=script&lang=js&"
export * from "./RestaurantTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e85e9",
  null
  
)

export default component.exports